import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const TranslateSection = () => {
  const navigate = useNavigate();
  
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-muted/30">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="space-y-6">
            <h2 className="text-3xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              Traduza textos para criar conteúdo global
            </h2>
            <p className="text-muted-foreground">
              Traduza facilmente seus textos entre mais de 10 idiomas para criar conteúdo para vídeos, blogs e redes sociais. Integre com ferramentas como LipSync, Canva e Adobe Express.
            </p>
            <ul className="space-y-2">
              <li className="flex items-start">
                <span className="bg-primary/20 text-primary p-1 rounded-full mr-2">✓</span>
                <span>Traduza entre português, inglês, espanhol e outros idiomas</span>
              </li>
              <li className="flex items-start">
                <span className="bg-primary/20 text-primary p-1 rounded-full mr-2">✓</span>
                <span>Crie vídeos no LipSync com texto traduzido</span>
              </li>
              <li className="flex items-start">
                <span className="bg-primary/20 text-primary p-1 rounded-full mr-2">✓</span>
                <span>Integre com Blogger, Pinterest e outras plataformas</span>
              </li>
              <li className="flex items-start">
                <span className="bg-primary/20 text-primary p-1 rounded-full mr-2">✓</span>
                <span>Histórico de traduções recentes</span>
              </li>
            </ul>
            <div className="flex flex-wrap gap-4">
              <Button 
                onClick={() => navigate("/translate")}
                className="bg-primary text-primary-foreground hover:bg-primary/90"
              >
                Abrir Tradutor <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
              <Button 
                variant="outline" 
                onClick={() => window.open("https://translate.google.com.br/?sl=es&tl=en&op=translate", "_blank")}
              >
                Google Tradutor
              </Button>
            </div>
          </div>
          
          <div className="rounded-lg overflow-hidden shadow-lg bg-card">
            <div className="aspect-video relative bg-gradient-to-br from-primary/10 to-accent/10 flex items-center justify-center">
              <img 
                src="https://storage.googleapis.com/fenado-ai-farm-public/generated/0349a7b1-17fd-4b2f-a91c-f05b35d5f3f5.webp"
                alt="Tradutor de Textos"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-black/70 text-white p-4 text-center">
                "Olá! Hello! Hola! Bonjour! Ciao! 你好! こんにちは!"
              </div>
            </div>
            <div className="p-4 space-y-4">
              <h3 className="font-semibold">Como usar o tradutor</h3>
              <ol className="space-y-2 text-sm text-muted-foreground">
                <li className="flex items-center">
                  <span className="bg-primary/20 text-primary rounded-full h-5 w-5 flex items-center justify-center mr-2 text-xs">1</span>
                  <span>Escolha o idioma de origem e destino</span>
                </li>
                <li className="flex items-center">
                  <span className="bg-primary/20 text-primary rounded-full h-5 w-5 flex items-center justify-center mr-2 text-xs">2</span>
                  <span>Digite o texto a ser traduzido</span>
                </li>
                <li className="flex items-center">
                  <span className="bg-primary/20 text-primary rounded-full h-5 w-5 flex items-center justify-center mr-2 text-xs">3</span>
                  <span>Clique em "Traduzir texto"</span>
                </li>
                <li className="flex items-center">
                  <span className="bg-primary/20 text-primary rounded-full h-5 w-5 flex items-center justify-center mr-2 text-xs">4</span>
                  <span>Copie o texto traduzido</span>
                </li>
                <li className="flex items-center">
                  <span className="bg-primary/20 text-primary rounded-full h-5 w-5 flex items-center justify-center mr-2 text-xs">5</span>
                  <span>Use em suas ferramentas de criação de conteúdo</span>
                </li>
              </ol>
              <Button 
                variant="link" 
                className="p-0 text-primary" 
                onClick={() => navigate("/translate")}
              >
                Saiba mais
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TranslateSection;